import * as React from "react";
export default class HeaderDefault extends React.Component {
    constructor(props) {
        super(props);
    }
    render() {
        return (React.createElement("div", { className: "header-C" },
            React.createElement("div", { className: "back-to-results" },
                React.createElement("a", { href: "/" },
                    React.createElement("i", { className: "fa fa-arrow-left" }),
                    React.createElement("span", null, "Go To Liquor Connect"))),
            React.createElement("img", { className: "store-logo", src: "http://sherbrookeliquor.com/wp-content/uploads/2014/08/SB-Logo-stroke.png" }),
            React.createElement("div", { className: "save-as-favorite" },
                React.createElement("i", { className: "fa fa-star-o" }),
                React.createElement("span", null, "Save"))));
    }
}
;
//# sourceMappingURL=header.js.map